import { sessionStorage } from '@fiverr-private/futile';
import { getContext } from '@fiverr-private/fiverr_context';
import { logger } from '@fiverr-private/obs';
import { clientAllocate } from '@fiverr-private/experiments';
import { Experiments } from '../../shared/constants';
import { globalMixpanelReporter } from '../../events/mixpanel';
import { AUTO_SHOWN_KEY, PAGE_VIEW_INCREASED_THRESHOLD, PAGE_VIEW_THRESHOLD } from './constants';
import { legacyPageViewTracker } from './tracker';

interface IsAutoShowEligibleProps {
    autoShowSignUpEnabled: boolean;
    pageViews: number;
    threshold: number;
}

export const handleAutoShowSignUp = ({
    autoShowSignUpEnabled = true,
    inLynxesIdentificationAutoshowModalRollout = false,
}) => {
    const pageViews = legacyPageViewTracker.track();
    const context = getContext();

    if (context.abTests[Experiments.LYNXES_IDENTIFICATION_AUTOSHOW_MODAL]) {
        return false;
    }

    const isEligibleWithDefaultThreshold = isAutoShowEligible({
        autoShowSignUpEnabled,
        pageViews,
        threshold: PAGE_VIEW_THRESHOLD,
    });

    if (isEligibleWithDefaultThreshold) {
        const group = clientAllocate({
            experimentId: Experiments.LYNXES_IDENTIFICATION_AUTOSHOW_MODAL_V2,
            numOfGroups: 2,
            rolloutResult: inLynxesIdentificationAutoshowModalRollout,
            experimentType: 'guest',
        });

        if (typeof group === 'number') {
            globalMixpanelReporter.enrichContext({ identificationAutoshowModalExperiment: group }, { preserve: true });

            return group === 1;
        }
    }

    const isEligibleWithIncreasedThreshold = isAutoShowEligible({
        autoShowSignUpEnabled,
        pageViews,
        threshold: PAGE_VIEW_INCREASED_THRESHOLD,
    });

    const isAllocatedToTest = Number(context.abTests[Experiments.LYNXES_IDENTIFICATION_AUTOSHOW_MODAL_V2]) === 2;

    if (isEligibleWithIncreasedThreshold && isAllocatedToTest) {
        return true;
    }

    return isEligibleWithDefaultThreshold;
};

const isAutoShowEligible = ({ autoShowSignUpEnabled, pageViews, threshold }: IsAutoShowEligibleProps) => {
    const { userId } = getContext();
    const reachedPageViewThreshold = pageViews === threshold;
    const isShown = sessionStorage.get(AUTO_SHOWN_KEY);

    return !userId && autoShowSignUpEnabled && reachedPageViewThreshold && !isShown;
};

export const setAutoShown = () => {
    sessionStorage.set(AUTO_SHOWN_KEY, true).catch((error) =>
        logger.warn(error, {
            description: 'Failed setting auto shown sign up key',
        })
    );
};
